import { trace as traceOrigin } from '../core/Trace.js';

export class Trace extends traceOrigin.constructor {
    constructor() {
        super();
        this.init("nine-util", "green");
    }
}

export const trace = new Trace();